<div class="container">
  <div class="top">
    <h3>Ver comprovantes</h3>
  </div>
  <div class="buttons">
    <yoo-button
      neutral
      large
      regular
      [block]="true"
      (click)="handleClose('USER')"
    >
      <span>Meus comprovantes</span>
    </yoo-button>
    <yoo-button
      neutral
      large
      regular
      [block]="true"
      (click)="handleClose('ALL')"
    >
      <span>Comprovantes da mesa</span>
    </yoo-button>
  </div>
</div>